import React from 'react'
import { FileText, ShieldCheck, AlertTriangle, BookOpen, Clock, HeartHandshake } from 'lucide-react'
import './VolunteeringRules.css'

const VolunteeringRules = () => {
  return (
    <div className="rules-page">
      <div className="rules-hero">
        <div className="rules-hero-content">
          <h1>
            <FileText size={40} className="hero-icon" />
            Reglamento de Voluntariado
          </h1>
          <p>Lineamientos, derechos y deberes para todos los participantes del programa de voluntariado de VTIC.</p>
        </div>
      </div>

      <div className="rules-container">
        
        <section className="rules-section intro">
          <h2><BookOpen className="section-icon" /> 1. Disposiciones Generales</h2>
          <p>
            El presente reglamento tiene como propósito establecer las normas básicas de convivencia,
            derechos y obligaciones aplicables a todos los miembros inscritos en el programa de voluntariado
            y tutorías del portal VTIC.
          </p>
          <p>
            Ser voluntario implica un compromiso ético y profesional con la comunidad universitaria,
            brindando apoyo desinteresado y fomentando el aprendizaje colaborativo.
          </p>
        </section>

        <section className="rules-section duties">
          <h2><Clock className="section-icon" /> 2. Deberes del Voluntario</h2>
          <ul className="rules-list">
            <li><strong>Cumplimiento de Horarios:</strong> Respetar rigurosamente los horarios y fechas establecidos para las tutorías o actividades asignadas. En caso de inasistencia, notificar con al menos 24 horas de anticipación.</li>
            <li><strong>Responsabilidad Académica:</strong> Brindar información precisa y de calidad. Evitar realizar los trabajos o exámenes en lugar del estudiante; el objetivo es orientar y facilitar el aprendizaje.</li>
            <li><strong>Carácter Apolítico y Laico:</strong> El programa persigue fines estrictamente académicos y colaborativos. Queda prohibida la promoción de agendas políticas, religiosas u organizacionales de índole partícipe durante las actividades de voluntariado.</li>
            <li><strong>Respeto y Tolerancia:</strong> Mantener un trato cordial, respetuoso y libre de discriminación hacia todos los miembros de la comunidad sin importar su origen, género, religión o nivel de conocimientos.</li>
            <li><strong>Uso Ético de la Plataforma:</strong> Utilizar las herramientas del portal VTIC únicamente con fines académicos. Queda prohibido el spam, publicidad no autorizada o recopilación de datos personales.</li>
            <li><strong>Confidencialidad:</strong> Mantener en reserva cualquier información sensible académica o personal que el estudiante comparta durante las sesiones.</li>
          </ul>
        </section>

        <section className="rules-section rights">
          <h2><ShieldCheck className="section-icon" /> 3. Derechos del Voluntario</h2>
          <ul className="rules-list">
            <li><strong>Reconocimiento Oficial:</strong> Obtener las constancias y el registro de horas académicas exclusivamente por participación en la PHUMA, derivado del trabajo realizado y verificado a través de la plataforma.</li>
            <li><strong>Ambiente Seguro:</strong> Desempeñar sus actividades en un entorno de respeto. Cualquier abuso por parte de un alumno puede ser reportado y resultará en la suspensión del alumno.</li>
            <li><strong>Flexibilidad:</strong> Establecer sus propios horarios de disponibilidad y tener la potestad de rechazar sesiones que no se ajusten a su agenda (siempre que se haga con previo aviso o no se hayan confirmado).</li>
            <li><strong>Capacitación:</strong> Acceso preferencial a herramientas, guías y capacitaciones proporcionadas por los organizadores del portal para mejorar sus habilidades docentes.</li>
          </ul>
        </section>

        <section className="rules-section final">
          <h2><HeartHandshake className="section-icon" /> 4. Aceptación</h2>
          <p>
            Al registrarte como tutor, investigador o voluntario en VTIC, declaras haber leído, entendido y aceptado los lineamientos de este reglamento en su totalidad. 
            Modificaciones a este documento serán notificadas por medio del portal oficial.
          </p>
        </section>

      </div>
    </div>
  )
}

export default VolunteeringRules
